import { useTranslation } from 'react-i18next';
import { Snackbar, SnackbarMessage, SnackbarVariant } from 'app/components/core/Snackbar';

export function AnalyzeSchemaUsageFailureNotification({ id, type, onDismiss, schemaToAnalyze }) {
    const { t } = useTranslation();

    return (
        <Snackbar id={id} onDismiss={onDismiss} variant={SnackbarVariant.ERROR}>
            <SnackbarMessage>
                {t(`notifications:${type}`, { schemaName: schemaToAnalyze.schema })}
            </SnackbarMessage>
        </Snackbar>
    );
}
